<template>
  <section class="creditos-shell">
    <div class="creditos-panel">
      <div class="creditos-summary" aria-label="Resumen de creditos">
        <div class="summary-card">
          <span class="summary-label">Total cartera</span>
          <strong>{{ ready ? creditos.length : "--" }}</strong>
          <small>Creditos encontrados</small>
        </div>
        <div class="summary-card">
          <span class="summary-label">Activos</span>
          <strong>{{ resumenEstados.activos }}</strong>
          <small>En seguimiento</small>
        </div>
        <div class="summary-card">
          <span class="summary-label">Vencidos</span>
          <strong>{{ resumenEstados.vencidos }}</strong>
          <small>Requieren atencion</small>
        </div>
        <div class="summary-card">
          <span class="summary-label">Monto aprobado</span>
          <strong>{{ formatoNumero(resumenEstados.monto) }}</strong>
          <small>{{ moneda.toUpperCase() }}</small>
        </div>
      </div>

      <div class="table-frame">
    <table class="table align-middle creditos-table" id="myTable">
      <thead>
        <tr>
          <th class="">Código</th>
          <th class="">Beneficiario</th>
          <th class="">Identidad</th>
          <th class="">Producto</th>
          <th class="">Sucursal</th>
          <th class="">Estado</th>
          <!-- <th class="">Saldo Capital</th> -->
          <th class="">Monto Aprobado</th>
          <th class="" data-sorteable="false">Acciones</th>
          <!--             <th v-if="this.Admin === true" class="" >Volver</th> -->
          <th>Volver</th>
        </tr>
      </thead>
      <tbody v-if="this.ready && this.creditos.length > 0">
        <tr v-for="(credito, index) in this.creditos" :key="credito.id">
          <td class="codigo-cell">{{ String(index + 1).padStart(3, "0") }}</td>
          <td class="beneficiario-cell notranslate">
            <div class="beneficiario-content">
              <span class="avatar">{{ initials(credito) }}</span>
              <strong>{{ credito.cliente.nombres }} {{ credito?.cliente.apellidos }}</strong>
            </div>
          </td>
          <td>{{ credito.cliente.dni }}</td>
          <td>{{ credito.solicitud.producto }}</td>
          <td>{{ credito.solicitud.sucursal }}</td>
          <td>
            <span :class="['estado-badge', estadoClass(credito?.estado)]">
              {{ estadoLabel(credito?.estado) }}
            </span>
          </td>

          <td class="monto-cell">
            {{ this.formatoNumero(credito?.montoOtorgado) }}
            <span>{{ this.moneda }}</span>
          </td>
          <td>
            <div class="action-group">
            <button
              v-if="isCancelled(credito)"
              class="btn action-button action-button--disabled"
              disabled
              title="Pago deshabilitado"
            >
              <i class="fa-solid fa-dollar-sign"></i>
              <span>Pago</span>
            </button>
            <button
              v-else-if="canMakePayment(credito)"
              class="btn action-button action-button--pay"
              data-bs-toggle="modal"
              data-bs-target="#hacerPago"
              title="Hacer pago"
              @click="handleMoveInfo(credito?.id, credito?.fechaUltimaPago)"
            >
              <i class="fa-solid fa-dollar-sign"></i>
              <span>Pago</span>
            </button>
            <button
              v-else-if="this.Finanzas !== true"
              class="btn action-button action-button--disabled"
              data-bs-toggle="modal"
              data-bs-target="#hacerPago"
              disabled
            >
              <i class="fa-solid fa-check"></i>
              <span>Pagado</span>
            </button>
            <!-- <a :href="`/solicitud-aceptada/`" class="btn btn-am btn-inverse-primary">Ver más</a> -->
            <!-- Aqui va ver Mas buton -->

            <!-- <ver-mas   :aprobadoCoordinador="credito.aprobadoJefe" :aprobadoJefe="credito.aprobadoJefe" :id="credito.id" :clienteID="credito.cliente.id"/> -->

            <button
              class="btn action-button action-button--view"
              data-bs-toggle="modal"
              data-bs-target="#resumenCredito"
              title="Ver mas"
              @click="handleSeeMore(credito.id)"
            >
              Ver más
            </button>
            <!-- <button class="btn btn-am btn-inverse-primary" data-bs-toggle="modal"
                            data-bs-target="#resumenCredito" @click="handleSeeMore(credito.id)"><i
                                v-if="credito.aprobadoCoordinador" class="fa-solid fa-check-double"></i> &nbsp; Ver
                            más &nbsp; <i v-if="credito.aprobadoJefe" class="fa-solid fa-crow"></i></button> -->
            </div>
          </td>
          <td
            v-if="this.Admin === true || this.modoThanos === true"
            class="text-center"
          >
            <button
              v-if="this.Admin === true || this.modoThanos === true"
              class="btn btn-volver"
              @click="llamarEspejo(credito?.id)"
            >
              <i class="fa-solid fa-arrow-rotate-left"></i>
            </button>
          </td>
          <td v-else-if="this.Admin !== true" class="text-center"></td>
        </tr>
      </tbody>
      <tbody v-else-if="this.ready && this.creditos.length === 0">
        <tr>
          <td colspan="9" class="text-center">
            <div class="empty-state">
              <i class="fa-regular fa-folder-open mb-2"></i>
              <p class="mb-1">No hay créditos disponibles.</p>
              <small>Intenta ajustar los filtros o realiza una nueva búsqueda de beneficiarios.</small>
            </div>
          </td>
        </tr>
      </tbody>
      <!-- <tbody v-else-if="this.busqueda == '' && this.creditos.lenght == 0 ">
                <tr>
                    <td colspan="10" class="text-center">
                        <p class="mt-2">Realiza tu Busqueda 😁</p>
                    </td>
                </tr>
            </tbody> -->
      <tbody v-else>
        <tr>
          <td colspan="9" class="text-center">
            <div class="spinner-border text-warning text-center" role="status">
              <span class="visually-hidden text-center" colspan="9" col
                >Loading...</span
              >
            </div>
          </td>
        </tr>
      </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Modales -->
  <ResumenCreditoModal
    :modal-state="$data"
    :actions="resumenCreditoActions"
  />
  <HacerPagoModal
    :modal-state="$data"
    :actions="hacerPagoActions"
  />

  <!-- <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">Plan de Pagos</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" data-bs-toggle="modal"
                        aria-label="Close" data-bs-target="#hacerPago"></button>
                </div>
                <div class="modal-body">
                    <div id="contenedorTabla">
                        <div class="header d-flex justify-content-between p-3">
                            <h2>Tabla de amortizaciones</h2>
                            <button @click="handleImprimirPlanPago()" type="button" class="btn btn-success"
                                style="color:white; margin:0;">
                                Exportar Plan De Pago <i class="fa-solid fa-download"></i>
                            </button>
                        </div>
                        <table class="table table-striped table-hover">

                            <thead class="table-dark">
                                <tr>
                                    <th scope="col">No. Cuota</th>
                                    <th scope="col">Fecha de Pago</th>
                                    <th scope="col">Cuota Total</th>
                                    <th scope="col">Interés</th>
                                    <th scope="col">Capital</th>
                                    <th scope="col">Saldo</th>
                                    <th scope="col">Capial DT</th>
                                </tr>
                            </thead>
                            <tbody id="tablaPlanPagos">

                            </tbody>
                        </table>
                        <div id="amortizaciones">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-bs-toggle="modal"
                        data-bs-target="#hacerPago">Cerrar</button>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import DataTable from "datatables.net";
// import { DataTable } from "simple-datatables"

import Security from "../security";
// import VerMas from './VerMas.vue';
import { solicitudCompleta } from "../solicitud.js";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
// import router from '@/router';
import ExcelJS from "exceljs";
import { store } from "../store";
import ResumenCreditoModal from "./ResumenCreditoModal.vue";
import HacerPagoModal from "./HacerPagoModal.vue";

export default {
  data() {
    return {
      readyInfoRegistro: false,

      bancosFallback: [
        {
          nombreBanco: "Atlantida",
          cuentas: [
            "10120625735",
            "10120625743",
            "10120625750",
            "10120625750",
            "10111039284",
            "10120625768",
          ],
        },
        {
          nombreBanco: "Ficohsa",
          cuentas: [
            "200014395554",
            "200014395619",
            "200014395759",
            "200014396542",
          ],
        },
        {
          nombreBanco: "Banrural",
          cuentas: [
            "15110490970",
            "15110491370",
            "15110491384",
            "15110491398",
            "15110496114",
            "15110496132",
            "15110496146",
            "15310166680",
            "15310167484",
          ],
        },
        {
          nombreBanco: "Crédito Solidario",
          cuentas: ["21-401-177888-4", "02701010052409"],
        },
      ],
      bancos: [],
      imgPath: process.env.VUE_APP_IMAGE_URL,
      slug: "",
      noCuenta: "",
      numerosDeCuenta: [],
      esRefinanciado: false,
      nombreBanco: "",
      fechaPagado: "",
      moneda: "lps",
      departamentos: [],
      montoPagado: 0,
      idCredito: 0,
      fechaUltimoPago: "",
      isLoading: false,
      sendImageToServer: false,
      fechaDataUltimoPago: "",
      noReferenciaRecibo: "",
      recibo: null,
      tipoPago: "credito",
      estado: "Activo",
      hacerPagoInfo: {},
      solicitudCompleta,
      creditos: [],
      creditosOptimizados: [],
      data: [],
      dateFormated: "",
      ready: false,
      imagenPegada: null,
      readyExcel: false,
      filtradoMostrar: "",
      verMasData: [],
      depto: "",
      solicitud: {},
      sucursalesRoles: [],
      pagos: [],
      sucursal: "",
      roles: [
        "Coordinacion",
        "Admin",
        "Finanzas",
        "Asesor",
        "Cordinador Sucursal",
        "Consultor",
      ],
      Finanzas: false,
      Admin: false,
      Coordinacion: false,
      Asesor: false,
      coordinadorSucursal: false,
      modoThanos: false,
      Consultor: false,
      readyVerMas: false,
      userRoles: [],
      estadoSeleccionado: "",
      contadorArchivos: 0,
      busquedaInput: "",
      esLocalizable: "true",
      estadoProceso: "",

      asesorAdmin: "",

      //Asesores
      asesores: [],
      asesor: 0,

      estadoProcesoBool: false,

      totalMontoPagado: 0,
      store,
      dataTableInstance: null,
    };
  },
  props: {
    busqueda: String,
  },
  components: {
    // VerMas,
    ResumenCreditoModal,
    HacerPagoModal,
  },
  computed: {
    resumenEstados() {
      return this.creditos.reduce(
        (acc, credito) => {
          const estado = this.mayusculasSinEspacios(credito?.estado || "");
          acc.monto += Number(credito?.montoOtorgado) || 0;

          if (estado === "ACTIVO") acc.activos += 1;
          if (estado === "VENCIDO") acc.vencidos += 1;
          if (estado === "CANCELADO") acc.cancelados += 1;

          return acc;
        },
        {
          activos: 0,
          vencidos: 0,
          cancelados: 0,
          monto: 0,
        }
      );
    },
    resumenCreditoActions() {
      return {
        dateFormat: (param) => this.dateFormat(param),
        formatoNumero: (numero) => this.formatoNumero(numero),
        detailsRnp: () => this.detailsRnp(),
        redirect: () => this.redirect(),
        guardarEstadoProceso: () => this.guardarEstadoProceso(),
        comprobarEstado: (estado) => this.comprobarEstado(estado),
        convertirANoNegativo: (numero) => this.convertirANoNegativo(numero),
        comprobarData: (event) => this.comprobarData(event),
        cambiarEstado: (idCredito, estado) => this.cambiarEstado(idCredito, estado),
        cambiarAsesor: (idCredito, idAsesor) => this.cambiarAsesor(idCredito, idAsesor),
        simularPagos: () => this.simularPagos(),
        handleRead: (idPago) => this.handleRead(idPago),
        deletePayment: (idPago) => this.deletePayment(idPago),
        setState: (key, value) => {
          this[key] = value;
        },
      };
    },
    hacerPagoActions() {
      return {
        dateFormat: (param) => this.dateFormat(param),
        formatoNumero: (numero) => this.formatoNumero(numero),
        handleImprimirEstadoCuenta: () => this.handleImprimirEstadoCuenta(),
        fechaPagadoHoy: () => this.fechaPagadoHoy(),
        loadCoverImage: (event) => this.loadCoverImage(event),
        pegarImagen: () => this.pegarImagen(),
        cleanData: () => this.cleanData(),
        handleSubmitPago: () => this.handleSubmitPago(),
        setState: (key, value) => {
          this[key] = value;
        },
      };
    },
  },
  beforeMount() {
    Security.requireToken();
    this.fetchBancos();
    this.busquedaInput = this.busqueda;
    this.userRoles = Security.getUserRoles();
    // console.log(this.userRoles);
    this.roles.forEach((element) => {
      if (this.userRoles[0]?.some((role) => role.includes(element)) === true) {
        this[element] = true;
      } else if (
        this.userRoles[0]?.some((role) =>
          role.includes("Coordinador Sucursal")
        ) === true
      ) {
        this.coordinadorSucursal = true;
        // console.log('coordinador sucursal en true')
      } else if (
        this.userRoles[0]?.some((role) => role.includes("Modo Thanos")) === true
      ) {
        this.modoThanos = true;
        // console.log('Modo thanos en true')
      }
      /*       if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
                  } */
    });

    if (this.busqueda != "") {
      this.buscarCredito(this.busqueda);
    } else {
      this.creditos = this.obtenerDeLocalStorage("creditos") || [];
      this.busquedaInput = this.obtenerDeLocalStorage("busqueda");
      this.ready = true;
    }

    // Asesor
    fetch(
      process.env.VUE_APP_API_URL + "/admin/users/sucursal",
      Security.requestOptions({})
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          this.$emit("error", response.message);

          console.error(response.message);
        } else {
          console.log("Asesor Datos:", response.data);
          this.asesores = response.data.users;
        }
      })
      .catch((error) => {
        this.$emit("error", error);
      });
  },
  mounted() {
    this.$nextTick(() => this.initializeDataTable());
  },

  updated() {
    this.$nextTick(() => this.initializeDataTable());
  },
  beforeUnmount() {
    if (this.dataTableInstance) {
      this.dataTableInstance.destroy();
      this.dataTableInstance = null;
    }
  },

  methods: {
    fetchBancos() {
      fetch(
        process.env.VUE_APP_API_URL + "/admin/bancos/all",
        Security.requestOptions({})
      )
        .then((response) => this.readBancosResponse(response))
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            this.bancos = this.bancosFallback;
            return;
          }

          this.bancos = response.data?.bancos || [];
        })
        .catch((error) => {
          this.$emit("error", error);
          this.bancos = this.bancosFallback;
        });
    },
    readBancosResponse(response) {
      return response.text().then((text) => {
        if (!text) {
          return {};
        }

        try {
          return JSON.parse(text);
        } catch (error) {
          throw new Error(text);
        }
      });
    },
    sendMessage(){
      let payload
      payload = {
        idCredito: 1
      }
       fetch(
            process.env.VUE_APP_API_URL + "/admin/notificame/send-sms",
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                Swal.fire({
                  // position: 'top-end',
                  icon: "error",
                  title: data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              } else {
                console.log(data.data);
                Swal.fire({
                  icon: "success",
                  title: "Mensaje Enviado con exito!",
                  showConfirmButton: false,
                  timer: 1500,
                });
                // Recarga la página actual
                // location.reload();
              }
            });
    },
    fechaPagadoHoy(){
      const hoy = new Date();
      const year = hoy.getFullYear();
      const month = String(hoy.getMonth() + 1).padStart(2, '0');
      const day = String(hoy.getDate()).padStart(2, '0');
      this.fechaPagado = `${year}-${month}-${day}`;
    },
    detailsRnp() {
      if (this.readyInfoRegistro) {
        this.readyInfoRegistro = false;
      } else {
        this.readyInfoRegistro = true;
      }
    },
    deletePayment(idPago) {
      const payload = {
        idPago: parseInt(idPago),
        idUsuario: store.user.id,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Estás Seguro que deseas Eliminar el pago?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("confirmado");
          // this.buscarCredito(this.busquedaInput);

          fetch(
            process.env.VUE_APP_API_URL + "/admin/credito/eliminar-pago",
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                Swal.fire({
                  // position: 'top-end',
                  icon: "error",
                  title: data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              } else {
                console.log(data.data);
                Swal.fire({
                  icon: "success",
                  title: "Pago Eliminado Exitosamente!",
                  showConfirmButton: false,
                  timer: 1500,
                });
                // Recarga la página actual
                location.reload();
              }
            });
        }
      });
    },
    handleRead(idPago) {
      window.open(`/detalle-pago/${idPago}`, "_blank");
    },

    handleDelete() {
      console.log("Eliminar acción ejecutada");
    },
    guardarEstadoProceso() {
      let payload = {
        idCredito: this.idCredito,
        esLocalizable: this.esLocalizable === "true",
        estadoProceso: this.estadoProceso,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Deseas Actualizar el Estado de Proceso?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('confirmado')
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/estado-proceso`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                console.log("Credito:", response);
                window.location.href = "/cartera";
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
    },
    initializeDataTable() {
      const table = document.querySelector("#myTable");
      if (!table) return;

      if (this.dataTableInstance) {
        this.dataTableInstance.destroy();
        this.dataTableInstance = null;
      }

      if (!this.ready || this.creditos.length === 0) return;

      this.dataTableInstance = new DataTable(table, {
        searching: false,
        language: {
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 a 0 de 0 registros",
          infoFiltered: "(filtrado de _MAX_ registros totales)",
          entries: {
            _: "registros",
            1: "registro",
          },
          paginate: {
            previous: "Anterior",
            next: "Siguiente",
          },
        },
      });
    },
    buscarCredito(busquedaInput) {
      const payload = {
        busqueda: busquedaInput,
      };

      fetch(
        process.env.VUE_APP_API_URL + "/admin/credito/busqueda-credito",
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);

            console.error(response.message);
          } else {
            console.log("creditos", response.data);
            this.creditos = response.data || [];
            this.ready = true;

            this.guardarEnLocalStorage("creditos", this.creditos);
            this.guardarEnLocalStorage("busqueda", this.busqueda);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    mayusculasSinEspacios(texto) {
      return String(texto || "").toUpperCase().replace(/\s/g, "");
    },
    estadoLabel(estado) {
      const estadoNormalizado = this.mayusculasSinEspacios(estado);
      return estadoNormalizado || "-";
    },
    estadoClass(estado) {
      const estadoNormalizado = this.mayusculasSinEspacios(estado);

      if (estadoNormalizado === "ACTIVO") return "estado-badge--active";
      if (estadoNormalizado === "CANCELADO") return "estado-badge--cancelled";
      if (estadoNormalizado === "VENCIDO") return "estado-badge--overdue";
      if (!estadoNormalizado) return "estado-badge--empty";

      return "estado-badge--neutral";
    },
    isCancelled(credito) {
      return this.mayusculasSinEspacios(credito?.estado) === "CANCELADO";
    },
    canMakePayment(credito) {
      return (
        !this.isCancelled(credito) &&
        (this.Admin === true ||
          this.Coordinacion === true ||
          this.Asesor === true ||
          this.Consultor === true)
      );
    },
    initials(credito) {
      const nombres = credito?.cliente?.nombres || "";
      const apellidos = credito?.cliente?.apellidos || "";
      const iniciales = `${nombres.charAt(0)}${apellidos.charAt(0)}`.trim();

      return iniciales.toUpperCase() || "CR";
    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(Number(numero) || 0);
    },

    guardarEnLocalStorage(
      clave,
      arrayDeObjetos,
      tamañoMaximo = 5 * 1024 * 1024
    ) {
      // 5MB por defecto
      // Convertimos el array de objetos a una cadena JSON
      const jsonString = JSON.stringify(arrayDeObjetos);

      // Calculamos el tamaño del JSON en bytes
      const tamañoJSON = new Blob([jsonString]).size;

      // Verificamos si el tamaño es menor al límite permitido
      if (tamañoJSON <= tamañoMaximo) {
        // Si el tamaño es adecuado, lo guardamos en el localStorage
        localStorage.setItem(clave, jsonString);
        console.log(
          `Guardado correctamente en localStorage. Tamaño: ${tamañoJSON} bytes`
        );
      } else {
        console.error(
          `Error: El array excede el tamaño máximo permitido de ${tamañoMaximo} bytes.`
        );
      }
    },
    obtenerDeLocalStorage(clave) {
      // Recuperamos la cadena JSON del localStorage
      const jsonString = localStorage.getItem(clave);

      // Verificamos si hay algo almacenado en la clave dada
      if (jsonString) {
        try {
          // Convertimos la cadena JSON de vuelta a un array de objetos
          const arrayDeObjetos = JSON.parse(jsonString);
          console.log("Array recuperado:", arrayDeObjetos);
          return arrayDeObjetos;
        } catch (error) {
          console.error("Error al convertir el JSON:", error);
          return null;
        }
      } else {
        console.warn(`No hay datos almacenados bajo la clave "${clave}"`);
        return null;
      }
    },

    closeModal() {
      const backdrop = document.querySelector(".modal-backdrop");
      document.getElementById("resumenCredito").classList.remove("show");
      if (backdrop) {
        backdrop.remove(); // Elimina el elemento del DOM
      }
    },
    closeModalHacerPago() {
      const backdrop = document.querySelector(".modal-backdrop");
      document.getElementById("hacerPago").classList.remove("show");
      document.getElementById("hacerPago").style.display = "none";
      if (backdrop) {
        backdrop.remove(); // Elimina el elemento del DOM
      }
    },
    eliminarPago(idPago) {
      Swal.fire({
        title: "¿Confirmar Data?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `Confirmar! `,
      }).then((result) => {
        if (result.isConfirmed) {
          console.log(idPago);

          // let payload = {
          //   idPago: idPago
          // }

          // fetch(process.env.VUE_APP_API_URL + `/admin/pagos/eliminar-pago`, Security.requestOptions(payload))
          //   .then((response) => response.json())
          //   .then((response) => {
          //     if (response.error) {
          //       this.$emit('error', response.message);
          //       console.error(response.message)
          //     } else {
          //       console.log('Credito:', response)
          //       // location.reload();
          //     }
          //   })
          //   .catch(error => {
          //     this.$emit('error', error)
          //   })
        }
      });
    },

    creditrabajo2() {
      return this.hacerPagoInfo.producto === "Credi Trabajo 2";
    },
    esAgricola(producto) {
      // Convertir a minúsculas y eliminar espacios
      producto = producto.trim().toLowerCase();

      if (producto === "agricola") {
        console.log("Es agricola");
        return true;
      } else {
        return false;
      }
    },

    sumarMeses(fecha, meses) {
      const nuevaFecha = new Date(fecha);
      nuevaFecha.setMonth(nuevaFecha.getMonth() + meses);
      console.log(nuevaFecha);
      return nuevaFecha;
    },

    loadCoverImage(event) {
      // //get a refernce to the input using ref
      // const file = this.$refs.coverInput.files[0];

      // //encode the file using the FileReader API
      // const reader = new FileReader();
      // reader.onloadend = () => {
      //   const base64String = reader.result
      //     .replace("data", "")
      //     .replace(/^.+,/, "");
      //   this.recibo = base64String;
      //   // alert(base64String)
      // }
      // reader.readAsDataURL(file);

      //   const file = this.$refs.coverInput.files[0];

      //   if (!file) {
      //     // No se seleccionó ningún archivo
      //     return;
      //   }

      //   // Verifica si el tipo de archivo es compatible
      //   const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      //   if (!allowedTypes.includes(file.type)) {
      //     alert('El formato de archivo seleccionado no es válido. Por favor, selecciona una imagen JPEG, JPG o PNG.');
      //     return;
      //   }

      //   const reader = new FileReader();

      //   // Manejo de eventos onloadstart, onloadend y onerror
      //   reader.onloadstart = () => {
      //     // Puedes mostrar un indicador de carga aquí si lo deseas
      //     this.isLoading = true;
      //   };

      //   reader.onloadend = () => {
      //     try {
      //       // Actualizar la variable recibo con la imagen base64
      //       this.recibo = reader.result.replace("data", "").replace(/^.+,/, "");

      //       // Oculta el indicador de carga al finalizar la carga
      //       this.isLoading = false;

      //       // Aquí la imagen está lista para ser enviada, puedes llamar a la función para enviarla al servidor
      //       this.sendImageToServer = true;
      //     } catch (error) {
      //       console.error('Error al cargar la imagen:', error);
      //       alert('Ocurrió un error al cargar la imagen. Por favor, inténtalo de nuevo.');
      //     }
      //   };

      //   reader.onerror = () => {
      //     console.error('Error al cargar la imagen:', reader.error);
      //     alert('Ocurrió un error al cargar la imagen. Por favor, inténtalo de nuevo.');
      //   };

      //   // Leer el archivo como una URL de datos
      //   reader.readAsDataURL(file);
      // },

      this.recibo = event.target.files[0];
      this.imagenPegada = null;
    },
    comprobarEstado(estado) {
      if (this.mayusculasSinEspacios(estado) === "CANCELADO") {
        return true;
      } else return false;
    },
    comprobarCrediTrabajo(producto) {
      if (
        producto === "Credi Trabajo" ||
        producto === "Credi Trabajo" ||
        producto === "Creditrabajo " ||
        producto === "credi trabajo" ||
        producto === "CREDI TRABAJO" ||
        producto === "CREDITRABAJO" ||
        producto === "creditrabajo" ||
        producto === "CREDITRABAJO " ||
        producto === "creditrabajo " ||
        producto === "Creditrabajo " ||
        producto === "Credi Trabajo " ||
        producto === " Credi trabajo" ||
        producto === "credi trabajo " ||
        producto === "Credi trabajo" ||
        producto === " credi trabajo"
      ) {
        return true;
      } else {
        return false;
      }
    },
    async pegarImagen() {
      try {
        // Pegar la imagen desde el portapapeles
        const clipboardItems = await navigator.clipboard.read();
        for (const clipboardItem of clipboardItems) {
          for (const type of clipboardItem.types) {
            if (type.startsWith("image/")) {
              const blob = await clipboardItem.getType(type);
              this.imagenPegada = URL.createObjectURL(blob);
              this.recibo = this.imagenPegada;
              return;
            }
          }
        }
        console.log("No se encontró ninguna imagen en el portapapeles.");
      } catch (error) {
        console.error("Error al pegar la imagen:", error);
      }
    },
    handleImprimirEstadoCuenta() {
      const doc = new jsPDF();

      this.agregarTextoCentrado("Estado de Cuenta", 0, 30, doc, 13);
      this.agregarTextoCentrado(
        this.dateFormat(this.fechaPagado),
        0,
        35,
        doc,
        10
      );
      // this.agregarTextoCentrado(`Fecha de Elaboración: ${new Date()}`,0 , 50 , doc)
      this.agregarTextoCentrado(
        `${this.hacerPagoInfo.nombres} ${this.hacerPagoInfo.apellidos}`,
        0,
        45,
        doc,
        12
      );

      const hondurasNow = this.getHondurasDate();

      this.agregarTexto(
        `Fecha de emisión: ${this.dateFormat2(hondurasNow)}`,
        20,
        160,
        doc,
        10
      );
      this.agregarTexto("Tasa:", 20, 70, doc, 10);
      this.agregarTexto(`${this.hacerPagoInfo.tasaInteres} %`, 60, 70, doc, 10);
      this.agregarTexto("Fecha de Otorgamiento:", 20, 75, doc, 10);
      this.agregarTexto(
        `${this.dateFormat(this.hacerPagoInfo.fechaOtorgamiento)}`,
        60,
        75,
        doc,
        10
      );
      this.agregarTexto("Monto del Crédito:", 20, 80, doc, 10);
      this.agregarTexto(
        `${this.formatoNumero(this.hacerPagoInfo.montoAprobado)} ${
          this.moneda
        }`,
        60,
        80,
        doc,
        10
      );
      this.agregarTexto("Total Pagado:", 20, 85, doc, 10);
      this.agregarTexto(
        `${this.formatoNumero(
          this.hacerPagoInfo.capitalAcumulado +
            this.hacerPagoInfo.totalInteresPagado +
            this.hacerPagoInfo.totalMoraPagada +
            this.hacerPagoInfo.totalArrInteresPagado
        )}  ${this.moneda}`,
        60,
        85,
        doc,
        10
      );
      // this.agregarTextoCentrado('Fecha Otorgado', -10, 70, doc, 12)

      // Define los encabezados y datos de la tabla
      // const headers = [['Saldo a la fecha']];
      this.agregarTextoCentrado("Saldo a la fecha:", 0, 100, doc, 12);

      const data = [
        [
          "Interes Corriente:",
          `${this.formatoNumero(this.hacerPagoInfo.interesPorPagar)} ${
            this.moneda
          }`,
        ],
        [
          "Interes Moratorio",
          `${this.formatoNumero(this.hacerPagoInfo.moraPorPagar)} ${
            this.moneda
          }`,
        ],
        [
          "Capital Pendiente",
          `${this.formatoNumero(this.hacerPagoInfo.capitalDebePagar)} ${
            this.moneda
          }`,
        ],
      ];

      if (this.hacerPagoInfo.montoArregloInteres > 0) {
        data.push([
          "Arreglo Interes",
          `${this.formatoNumero(this.hacerPagoInfo.montoArregloInteres)} ${
            this.moneda
          }`,
        ]);
      }
      const footer = [
        [
          "Total a pagar para estar al día",
          `${this.formatoNumero(this.hacerPagoInfo.totalMinimoAPagar)} ${
            this.moneda
          }`,
        ],
      ];
      const footer2 = [
        [
          "Total para Cancelar Crédito              ",
          `${this.formatoNumero(this.hacerPagoInfo.totalMontoCancelar)} ${
            this.moneda
          }`,
        ],
      ];

      // Crea la tabla en el documento
      doc.autoTable({
        // head: headers,
        foot: footer,
        body: data,
        startY: 100,
      });

      doc.autoTable({
        // head: headers,
        foot: footer2,
        // body: data,
        startY: 140,
      });

      doc.setFont("courier");

      // Calcula las dimensiones del documento
      const docWidth = doc.internal.pageSize.getWidth();
      // Agrega una imagen al documento
      const img = new Image();
      img.src = require("@/assets/header.png"); // Reemplaza 'mi_imagen.jpg' con el nombre de tu imagen
      // Calcula las dimensiones de la imagen para que ocupe todo el ancho de la página
      const imgWidth = docWidth;
      // const imgHeight = (img.height * imgWidth) / img.width;
      // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
      doc.addImage(img, "PNG", 0, 0, imgWidth, 30);

      // //        // Agregar texto al final de la página
      // let cuentaText = `Cuenta No. 15310167484 de BANRURAL`; // Tu texto aquí
      // const textWidth2 = doc.getTextWidth(cuentaText);
      // const centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
      // const bottomY = doc.internal.pageSize.height - 60; // Ajusta la posición vertical según tus necesidades
      // doc.text(cuentaText, centerX2, bottomY);

      // // Agregar texto al final de la página
      // let cuentaText3 = `_____________`; // Tu texto aquí
      // const textWidth3 = doc.getTextWidth(cuentaText3);
      // const centerX3 = (doc.internal.pageSize.width - textWidth3) / 2;
      // const bottomY3 = doc.internal.pageSize.height - 30; // Ajusta la posición vertical según tus necesidades
      // doc.text(cuentaText3, centerX3, bottomY3);
      // // Agregar texto al final de la página
      // let cuentaText4 = `FIRMA`; // Tu texto aquí
      // let textWidth4 = doc.getTextWidth(cuentaText4);
      // let centerX4 = (doc.internal.pageSize.width - textWidth4) / 2;
      // let bottomY4 = doc.internal.pageSize.height - 20; // Ajusta la posición vertical según tus necesidades
      // doc.text(cuentaText4, centerX4, bottomY4);
      // Guardar el PDF
      doc.save(
        `Estado de Cuenta-${this.hacerPagoInfo.nombres} ${
          this.hacerPagoInfo.apellidos ? this.hacerPagoInfo.apellidos : ""
        }.pdf`
      );
    },
    agregarTextoCentrado(text, ancho, altura, doc, fontSize) {
      doc.setFontSize(fontSize);

      const textWidth = doc.getTextWidth(text);
      // // Calcular la posición para centrar el texto

      const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      const y = 10;

      // // Colocar el texto centrado
      doc.text(text, centerX + ancho, y + altura);
    },
    agregarTexto(text, ancho, altura, doc, fontSize) {
      doc.setFontSize(fontSize);

      // const textWidth = doc.getTextWidth(text);
      // // Calcular la posición para centrar el texto

      // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      // const y = 10;

      // // Colocar el texto centrado
      doc.text(text, ancho, altura);
    },
    handleImprimirPlanPago() {
      const doc = new jsPDF();

      // const text = 'PLAN DE PAGO';
      // const textWidth = doc.getTextWidth(text);
      // this.agregarTextoCentrado(`Plan de Pago`, 0, 30, doc, 14)
      const text = "PLAN DE PAGO";
      // const textWidth = doc.getTextWidth(text);
      // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      let y = 20;
      // var tableHeight

      // Calcula las dimensiones del documento
      const docWidth = doc.internal.pageSize.getWidth();
      // Agrega una imagen al documento
      const img = new Image();
      img.src = require("@/assets/header.png"); // Reemplaza 'mi_imagen.jpg' con el nombre de tu imagen
      // Calcula las dimensiones de la imagen para que ocupe todo el ancho de la página
      const imgWidth = docWidth;
      // const imgHeight = (img.height * imgWidth) / img.width;
      // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
      doc.addImage(img, "PNG", 0, 0, imgWidth, 30);
      doc.setFontSize(12);
      doc.setTextColor(255, 255, 255);
      doc.text(text, 130, y - 6);

      // Calcular la posición para centrar el texto
      // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
      y = 30;

      // Colocar el texto centrado
      // doc.text(text, centerX, y);
      this.agregarTextoCentrado(
        `${this.hacerPagoInfo.nombres} ${this.hacerPagoInfo.apellidos}`,
        43,
        10,
        doc,
        11
      );

      doc.setFont("courier");

      const tableData = [];
      const tableInfoPrestamo = [];
      document.querySelectorAll(".datos-table tr").forEach((row) => {
        const rowData = [];
        // Iterar sobre las celdas de cada fila
        row.querySelectorAll("td").forEach((cell) => {
          rowData.push(cell.innerText);
        });

        tableData.push(rowData);
      });

      document.querySelectorAll(".datos-prestamo-table tr").forEach((row) => {
        const rowData = [];
        // Iterar sobre las celdas de cada fila
        row.querySelectorAll("td").forEach((cell) => {
          rowData.push(cell.innerText);
        });

        tableInfoPrestamo.push(rowData);
      });
      this.ejecutarPlanPagos();

      // Crear la tabla en el PDF
      doc.autoTable({
        body: tableData,
        theme: "striped", // Puedes cambiar el tema según tus preferencias
        styles: {
          halign: "center",
        },
      });
      doc.autoTable({
        body: tableInfoPrestamo,
        theme: "striped", // Puedes cambiar el tema según tus preferencias
        styles: {
          halign: "left",
        },
      });
      doc.autoTable({
        head: [
          [
            "No. Cuota",
            "Fecha de Pago",
            "Cuota Total",
            "Interes",
            "Capital",
            "Saldo",
          ],
        ],
        headStyles: { fillColor: [41, 128, 185] },
        body: this.planPagoToPrint.map((plan) => [
          plan.noCuota,
          plan.fechaPago,
          plan.cuotaTotal,
          plan.interes,
          plan.capital,
          plan.saldo,
        ]),
        theme: "grid",
        styles: {
          halign: "center",
        },
      });

      // Guardar el PDF
      doc.save(`${this.hacerPagoInfo.nombres.trim()}-Plan de Pago.pdf`);
    },
    getHondurasDate() {
      const now = new Date(); // Hora local del sistema
      const utcMs = now.getTime() + now.getTimezoneOffset() * 60000; // → UTC en ms
      const hnMs = utcMs + -6 * 60 * 60000; // UTC-6 → Honduras
      return new Date(hnMs);
    },

    // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
    CalculaCuotaNivelada(
      montoPrestamo,
      tasaInteres,
      periodos,
      periodo,
      diasPeriodo
    ) {
      if (periodo === 24) {
        periodos *= 2;
      } else if (periodo === 52.1) {
        periodos *= 4.33;
        periodos = Math.round(periodos);
      } else if (periodo === (30 / (periodos * 30)) * 12) {
        periodos = 1;
      } else if (periodo === 4) {
        periodos /= 3;
        // periodos = Math.round(periodos);
      } else if (periodo === 2) {
        periodos /= 6;
        // periodos = Math.round(periodos);
      } else if (periodo === 1) {
        periodos /= 12;
        // periodos = Math.round(periodos);
      }

      let tasaMensual = (tasaInteres / 360) * diasPeriodo;
      tasaMensual = Math.round(tasaMensual * 10000000000) / 10000000000;

      let cuota =
        (montoPrestamo * tasaMensual) /
        (1 - Math.pow(1 + tasaMensual, -periodos));
      return cuota;
    },
    stringToDate(dateString) {
      // Cadena con formato mm/dd/yyyy
      // Diseño que coincide con el formato de la cadena
      let date = new Date(dateString.split("/").join("-").slice(0, 10));
      date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return date;
    },
    // redirect() {
    //     //router.push(`/soli-credito/${this.verMasData.solicitud?.id}`)
    //     window.location.href = `/soli-credito/${this.verMasData.id}`
    // },
    redirect() {
      window.open(`/soli-credito/${this.verMasData.id}`, "_blank");
    },
    simularPagos() {
      window.open(`/simular-pagos/${this.verMasData.id}`, "_blank");
    },

    ejecutarPlanPagos() {
      const tablaBody = document.getElementById("tablaPlanPagos");
      const solicitud = {
        fechaPago: this.hacerPagoInfo.fechaOtorgamiento,
        monto: this.hacerPagoInfo.montoAprobado,
        frecuenciaPago: this.hacerPagoInfo.frecuenciaPago,
        interes: this.hacerPagoInfo.tasaInteres,
        plazoPago: this.hacerPagoInfo.plazoPago,
        producto: this.hacerPagoInfo.producto,
        periodoGracia: this.hacerPagoInfo.periodoGracia,
        fechaFija: this.hacerPagoInfo.fechaFija,
      };
      this.solicitud = this.hacerPagoInfo;
      // console.log(solicitud.fechaPago, solicitud.monto, solicitud.frecuenciaPago, solicitud.interes, solicitud.plazoPago)
      if (
        solicitud.fechaPago === "" ||
        solicitud.monto === "" ||
        solicitud.frecuenciaPago === "" ||
        solicitud.interes === "" ||
        solicitud.plazoPago === ""
      ) {
        tablaBody.innerHTML = `
          <tr>
            <td colspan=6 class="text-center text-danger">
              <h3>
                ¡Faltan datos!</td>  
              </h3>
          </tr>
        `;
      } else {
        this.generarPlanPago(
          this.stringToDate(solicitud.fechaPago),
          solicitud.monto,
          solicitud.frecuenciaPago,
          solicitud.interes,
          solicitud.plazoPago,
          solicitud.producto,
          solicitud.periodoGracia,
          solicitud.fechaFija
        );
      }
    },

    generarPlanPago(
      fechaApertura,
      monto,
      periodoPago,
      interesAnual,
      plazo,
      producto,
      periodoGracia,
      fechaFijaSolicitud
    ) {
      let fechaInicial = fechaApertura;
      // Calcular la tasa de interés mensual
      let tasaAnual = interesAnual / 100;
      let capitalDT = 0.0;
      let fechaFija = fechaFijaSolicitud;
      console.log("fechaFija", fechaFija);
      // console.log("tasa anual:", tasaAnual);

      // Calcular el intervalo de tiempo entre pagos
      let duracionPago, periodo, noCuotas, interes, diasPeriodo, capital, saldo;

      saldo = monto;

      switch (this.limpiarYMinusc(periodoPago)) {
        case "mensual":
          if (fechaFija) {
            duracionPago = 1;
            fechaApertura = this.sumarMeses(fechaApertura, 1);
          } else {
            duracionPago = 30 * 24 * 60 * 60 * 1000;
            fechaApertura = new Date(
              fechaApertura.getTime() + 30 * 24 * 60 * 60 * 1000
            );
          }
          noCuotas = plazo;
          periodo = 12;
          diasPeriodo = 30.0;
          break;

        case "quincenal":
          duracionPago = 15 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 15 * 24 * 60 * 60 * 1000
          );
          noCuotas = plazo * 2;
          periodo = 24;
          diasPeriodo = 15.0;
          break;

        case "semanal":
          duracionPago = 7 * 24 * 60 * 60 * 1000;
          fechaApertura = new Date(
            fechaApertura.getTime() + 7 * 24 * 60 * 60 * 1000
          );
          if (this.esCrediTrabajo(producto)) {
            noCuotas = plazo * 4;
          } else {
            noCuotas = plazo * 4.3333333333;
          }

          periodo = 52.1;
          diasPeriodo = 7.0;
          break;
        case "alvencimiento":
          duracionPago = 1;
          fechaApertura = new Date(
            fechaApertura.getTime() + plazo * 30 * 24 * 60 * 60 * 1000
          );
          noCuotas = 1;
          periodo = (30 / (plazo * 30)) * 12;
          diasPeriodo = plazo * 30;
          break;
        case "trimestral":
          if (this.esAgricola(producto)) {
            duracionPago = 3;
            fechaApertura = this.sumarMeses(fechaApertura, 3);
          } else {
            duracionPago = 90 * 24 * 60 * 60 * 1000;
            fechaApertura = new Date(
              fechaApertura.getTime() + 90 * 24 * 60 * 60 * 1000
            );
          }

          noCuotas = plazo / 3;
          periodo = 4;
          diasPeriodo = 90.0;
          break;
        case "semestral":
          if (this.esAgricola(producto)) {
            duracionPago = 6;
            fechaApertura = this.sumarMeses(fechaApertura, 6);
          } else {
            duracionPago = 180 * 24 * 60 * 60 * 1000;
            fechaApertura = new Date(
              fechaApertura.getTime() + 180 * 24 * 60 * 60 * 1000
            );
          }

          noCuotas = plazo / 6;
          periodo = 2;
          diasPeriodo = 180.0;
          break;
        case "anual":
          if (this.esAgricola(producto)) {
            duracionPago = 12;
            fechaApertura = this.sumarMeses(fechaApertura, 12);
          } else {
            duracionPago = 360 * 24 * 60 * 60 * 1000;
            fechaApertura = new Date(
              fechaApertura.getTime() + 360 * 24 * 60 * 60 * 1000
            );
          }

          noCuotas = plazo / 12;
          periodo = 1;
          diasPeriodo = 360.0;
          break;

        default:
          console.log("Periodo de pago no válido");
          return;
      }
      let cuotaTotal = 0.0;
      // Generar el plan de pago
      if (periodoGracia > 0) {
        cuotaTotal = this.CalculaCuotaNivelada(
          monto,
          tasaAnual,
          plazo - periodoGracia,
          periodo,
          diasPeriodo
        );
      } else {
        cuotaTotal = this.CalculaCuotaNivelada(
          monto,
          tasaAnual,
          plazo,
          periodo,
          diasPeriodo
        );
      }

      this.planPagoToPrint = [];
      const tablaBody = document.getElementById("tablaPlanPagos");
      tablaBody.innerHTML = "";
      tablaBody.innerHTML = `
        <tr>
          <th class="text-center align-middle" scope="row">0</td>
          <td class="text-center align-middle">${this.dateFormat(
            fechaInicial.toISOString().slice(0, 10)
          )}</td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle">${Number(saldo).toLocaleString(
            "en-US",
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )} ${this.moneda}</td>
          <td class="text-center align-middle">0</td>

        </tr>
      `;

      this.planPagoToPrint.push({
        noCuota: 0,
        fechaPago: this.dateFormat(fechaInicial.toISOString().slice(0, 10)),
        cuotaTotal: "",
        interes: "",
        capital: "",
        saldo: saldo.toFixed(2) + " " + this.moneda,
        capitalDT: capitalDT,
      });
      // Si no es Credito Agricola y no es Credito Trabajo 2
      if (
        this.comprobarCrediTrabajo(this.hacerPagoInfo.producto) !== true &&
        this.hacerPagoInfo.producto !== "Credi Trabajo 2"
      ) {
        let cuotaPagar;
        console.log("Cuota Total", cuotaTotal);

        for (let i = 1; i <= Math.round(noCuotas); i++) {
          console.log(i, noCuotas);
          interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          //  Si tiene periodo de gracia
          if (periodoGracia > 1 && i <= periodoGracia) {
            capital = 0;
            cuotaPagar = interes;
          } else {
            capital = cuotaTotal - interes;
            cuotaPagar = cuotaTotal;
          }
          saldo = this.convertirANoNegativo(saldo - capital);
          capitalDT += capital;
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(
              fechaApertura.toISOString().slice(0, 10)
            )}</td>
            <td class="text-center align-middle">${Number(
              cuotaPagar
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(
              interes
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(
              capital
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString(
              "en-US",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(
              capitalDT
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${this.moneda}</td>
            </tr>
          `;
          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(
              fechaApertura.toISOString().slice(0, 10)
            ),
            cuotaTotal:
              Number(cuotaTotal).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            interes:
              Number(interes).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            capital:
              Number(capital).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            saldo:
              Number(saldo).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            capitalDT:
              Number(capitalDT).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
          });

          if (
            (this.esAgricola(producto) &&
              this.limpiarYMinusc(periodoPago) != "mensual" &&
              this.limpiarYMinusc(periodoPago) != "semanal" &&
              this.limpiarYMinusc(periodoPago) != "quincenal") ||
            fechaFija
          ) {
            fechaApertura = this.sumarMeses(fechaApertura, duracionPago);
          } else {
            fechaApertura = new Date(fechaApertura.getTime() + duracionPago);
          }
        }
      } else {
        if (this.creditrabajo2) {
          noCuotas = Math.round(noCuotas);
        }
        cuotaTotal = monto / noCuotas;
        for (let i = 1; i <= Math.round(noCuotas); i++) {
          interes = ((saldo * tasaAnual) / 360) * diasPeriodo;
          capital = cuotaTotal;
          saldo = this.convertirANoNegativo(saldo - capital);
          capitalDT += capital;
          // Imprimir la fila de la tabla
          tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(
              fechaApertura.toISOString().slice(0, 10)
            )}</td>
            <td class="text-center align-middle">${cuotaTotal.toFixed(2)} ${
            this.moneda
          }</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${capital.toFixed(2)} ${
            this.moneda
          }</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString(
              "en-US",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(
              capitalDT
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${this.moneda}</td>
            </tr>
            `;
          this.planPagoToPrint.push({
            noCuota: i,
            fechaPago: this.dateFormat(
              fechaApertura.toISOString().slice(0, 10)
            ),
            cuotaTotal:
              Number(cuotaTotal).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            interes: "",
            capital:
              Number(capital).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            saldo:
              Number(saldo).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
            capitalDT:
              Number(capitalDT).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " " +
              this.moneda,
          });
          fechaApertura = new Date(fechaApertura.getTime() + duracionPago);
          // console.log(duracionPago);
          // fechaApertura = this.sumarMeses(fechaApertura, 6)
        }
      }
    },
    //Convertir string a minuscula y sin espacios
    limpiarYMinusc(string) {
      // Eliminar espacios en blanco y convertir a minúsculas
      return string.replace(/\s/g, "").toLowerCase();
    },
    //Convertir numero negativo a 0
    convertirANoNegativo(numero) {
      // Si el número es negativo, convertirlo a cero
      if (numero < 0) {
        return 0;
      } else {
        return numero;
      }
    },
    esCrediTrabajo(producto) {
      // Convertir producto a minúsculas para normalizar
      producto = producto.trim().toLowerCase();

      // Lista de valores normalizados
      const creditrabajo = [
        "creditrabajo",
        "credi trabajo",
        "credi trabajo ",
        "credi trabajo",
        "Credi Trabajo",
        "creditrabajo ",
        "creditrabajo ",
        "credi trabajo",
        "creditrabajo",
      ];

      // Verificar si el producto está en la lista de valores normalizados
      return creditrabajo.includes(producto);
    },
    handleImprimir() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(
        this.depto ? this.depto[0] : "Data"
      );
      worksheet.columns = [
        // { header: "ID", key: "id", width: 10 },
        { header: "Fecha Data", key: "fechaData", width: 10 },
        { header: "Número Prestamo", key: "noPrestamo", width: 20 },
        { header: "Identidad", key: "dni", width: 20 },
        { header: "Cliente", key: "nombres", width: 40 },
        { header: "Cliente RNP", key: "nombresRnp", width: 40 },
        { header: "Sexo", key: "sexo", width: 10 },
        { header: "Fecha Nacimiento", key: "fechaNacimiento", width: 10 },
        { header: "Monto Aprobado", key: "montoOtorgado", width: 20 },
        { header: "Producto Financiero", key: "producto", width: 20 },
        { header: "Tasa de Interes ", key: "interes", width: 10 },
        { header: "Plazo en meses", key: "plazoPago", width: 20 },
        {
          header: "Numero de cuotas según Plan",
          key: "noCuotasPlan",
          width: 15,
        },
        { header: "Cuota", key: "valorCuota", width: 15 },
        { header: "Saldo de Capital", key: "saldoCapital", width: 20 },
        { header: "Saldo de Interes", key: "saldoInteres", width: 20 },
        { header: "Saldo de Mora", key: "saldoMora", width: 20 },
        { header: "Saldo Seguro Deuda", key: "seguroDeuda", width: 15 },
        { header: "Saldo Seguro Daño", key: "seguroDaño", width: 15 },
        {
          header: "Seguro Vehiculo/Maquinaria",
          key: "seguroVehiculo",
          width: 15,
        },
        { header: "Capital Pagado", key: "capitalAcumulado", width: 20 },
        { header: "Otros", key: "otros", width: 20 },
        { header: "Capital Atrasado", key: "capitalAtrasado", width: 20 },
        { header: "Interes Pagado", key: "totalInteresPagado", width: 20 },
        { header: "Fecha Otorgado", key: "fechaOtorgamiento", width: 15 },
        { header: "Fecha Vencimiento", key: "fechaVencimiento", width: 15 },
        { header: "Dias Mora", key: "diasMora", width: 10 },
        { header: "FormaPago", key: "frecuenciaPago", width: 20 },
        { header: "Departamento", key: "sucursal", width: 20 },
        { header: "Municipio", key: "municipio", width: 20 },
        { header: "Direccion Personal", key: "puntoReferencia", width: 50 },
        { header: "Teléfono", key: "telefono", width: 20 },
        { header: "Tipo Credito", key: "tipoCredito", width: 15 },
        { header: "Categoría Crédito", key: "categoria", width: 10 },
        { header: "Garantía", key: "garantía", width: 10 },
        { header: "Estado Crédito", key: "estado", width: 20 },
        { header: "Categoría Riesgo Cliente", key: "riesgo", width: 10 },
        { header: "EsRefinanciado", key: "riesgo", width: 10 },
        { header: "Fecha Último pago", key: "fechaUltimoPago", width: 20 },
        {
          header: "Fecha Ultima Cuota Pagada",
          key: "fechaUltimaCuotaPagada",
          width: 20,
        },
        { header: "Cuotas Mora", key: "cuotasMora", width: 20 },
        { header: "Cuotas Pagadas", key: "cuotasPagadas", width: 20 },

        // { header: "Rubro", key: "actividadEconomica", width: 30 },
        // { header: "Direccion Negocio", key: "puntoReferenciaNegocio", width: 50 },
        // { header: "Fecha de Vencimiento", key: "fechaVencimiento", width: 20 },
        // { header: "Monto Otorgado", key: "montoOtorgadoReal", width: 20 },
        // { header: "No. de cuotas", key: "noCuotas", width: 10 },
        // { header: "No. de cuotas pagadas", key: "noCuotasPagadas", width: 10 },
        // { header: "Interes Moratorio", key: "totalMoraPagada", width: 10 },
        // { header: "Total Pagado", key: "totalPagado", width: 15 },
        // { header: "Fecha Ultima Pago", key: "fechaUltimaPago", width: 20 },
      ];
      worksheet.getRow(1).font = { bold: true };

      // for (let i = 0; i < this.creditos.length; i++) {
      //     this.creditos[i].pagoHoy = this.simularPagoHoy();
      // }
      const mappedData = this.creditos.map((credito) => ({
        // id: credito.id,
        fechaData: new Date().toISOString().slice(0, 10),
        noPrestamo: credito.noPrestamo,
        dni: credito.cliente.dni,
        nombres:
          credito.cliente.nombres +
          " " +
          (credito.cliente.apellidos ? credito.cliente.apellidos : ""),
        nombresRnp: credito.infoRegistro.nombre + " ",
        sexo: credito.infoRegistro.sexo,
        fechaNacimiento: credito.infoRegistro.fechaNacimiento,
        montoOtorgado: +credito.montoOtorgado,
        producto: credito.solicitud.producto,
        interes: credito.solicitud.interes + "%",
        plazoPago: credito.solicitud.plazoPago + " " + "Meses",
        noCuotasPlan: credito.noCuotas,
        valorCuota: credito.valorCuota,
        saldoCapital: credito.saldo > 0 ? credito.saldo : 0,
        // saldoInteres: "L." + (credito.capitalIntereses - credito.totalInteresPagado - credito.montoOtorgado).toFixed(2), //Pendiente Simulador
        saldoInteres:
          credito.simularPagoHoy.saldoInteres > 0
            ? credito.simularPagoHoy.saldoInteres
            : 0, //Pendiente Simulador
        saldoMora: credito.simularPagoHoy.saldoMora, //Pendiente Simulador
        seguroDeuda: "N/A",
        seguroDaño: "N/A",
        seguroVehiculo: "N/A",
        // capitalAcumulado: credito.capitalAcumulado,
        capitalAcumulado: this.comprobarEstado(credito.estado)
          ? credito.montoOtorgado
          : credito.capitalAcumulado,
        otros: this.comprobarEstado(credito.estado)
          ? credito.capitalAcumulado - credito.montoOtorgado
          : 0,
        // capitalAtrasado: (credito.saldo > 0 ? credito.saldo : 0),
        capitalAtrasado:
          credito.simularPagoHoy.capitalDebePagar > 0
            ? credito.simularPagoHoy.capitalDebePagar
            : 0,
        totalInteresPagado: credito.totalInteresPagado,
        fechaOtorgamiento: this.dateFormat(credito.fechaOtorgamiento),
        fechaVencimiento: this.dateFormat(credito.fechaVencimiento),
        diasMora: this.compareStrings(credito.estado, "cancelado")
          ? 0
          : credito.simularPagoHoy.diasMora, //Pendiente Simulador
        frecuenciaPago: credito.solicitud.frecuenciaPago,
        sucursal: credito.solicitud.sucursal,
        municipio: credito.cliente.municipio,
        puntoReferencia: credito.cliente.puntoReferencia,
        telefono: credito.cliente.telefono,
        tipoCredito: "pequeño",
        categoria: "|",
        estado: this.mayusculasSinEspacios(credito.estado),
        riesgo: credito.esRefinanciado ? "SI" : "NO",
        fechaUltimoPago: this.dateFormat(credito.fechaUltimaPago),
        fechaUltimaCuotaPagada: this.dateFormat(
          credito.simularPagoHoy.fechaUltimaCuotaPagada
        ), //Pendiente
        cuotasMora: 0, //Pendiente
        cuotasPagadas: credito.noCuotas - 1, //Pendiente

        // actividadEconomica: credito.cliente.actividadEconomica,
        // puntoReferenciaNegocio: credito.cliente.puntoReferenciaNegocio,
        // montoOtorgadoReal: credito.montoOtorgadoReal,
        // noCuotas: credito.noCuotas,
        // noCuotasPagadas: credito.noCuotasPagadas,
        // totalMoraPagada: credito.totalMoraPagada,
        // totalPagado: credito.totalPagado,
        // fechaUltimaPago: credito.fechaUltimaPago,
        // ... (rest of your properties)
      }));
      worksheet.addRows(mappedData);
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        // a.setAttribute("download", `CARTERA_${(this.sucursalesRoles[0] == 'ALL' ? "HISTORICA" : this.sucursalesRoles[0]) + "_AXCC" + "_" + this.hoy()}.xlsx`);
        a.setAttribute(
          "download",
          `CARTERA_${
            (this.sucursalFiltro == "MOSTRAR TODAS"
              ? "COMPLETA"
              : this.sucursalesRoles[0] == "ALL"
              ? this.sucursalFiltro
              : this.sucursalesRoles[0]) +
            "_AXCC" +
            "_" +
            this.estadoFiltro +
            "_" +
            this.hoy()
          }.xlsx`
        );
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    comprobarData(e) {
      // console.log(e.target.id)

      let payload = {
        tipoComprobacion:
          e.target.id === "cordinadorSucursal"
            ? "Coordinador Sucursal"
            : e.target.id === "Coordinacion"
            ? "Coordinacion"
            : null,
        idCredito: this.idCredito,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Confirmar Data?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('confirmado')
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/confirmacion-data`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                console.log("Credito:", response);
                // location.reload();
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
    },
    cambiarLegal(idCredito) {
      console.log("Se cambiar el estado a legal");
      let payload = {
        idCredito: idCredito,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Quieres cambiar el estado a Legal?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('confirmado')
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/estado-legal`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                console.log("Credito:", response);
                // location.reload();
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
    },
    cambiarEstado(idCredito, estado) {
      console.log("Se cambiar el estado a legal");
      let payload = {
        idCredito: idCredito,
        estado: estado,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Quieres cambiar el estado del crédito?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('confirmado')
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/cambio-estado`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                console.log("Credito:", response);
                // location.reload();
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
    },
    cambiarAsesor(idCredito, idAsesor) {
      console.log("Se cambiar el estado a legal");
      let payload = {
        idCredito: idCredito,
        idAsesor: idAsesor,
      };
      console.log(payload);
      Swal.fire({
        title: "¿Quieres cambiar el Asesor?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('confirmado')
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/update-asesor`,
            Security.requestOptions(payload)
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                console.log("Update Asesor:", response);
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
    },
    getCountArchivos() {
      fetch(
        process.env.VUE_APP_API_URL +
          `/admin/solicitud/count-archivos/${this.verMasData.id}`,
        Security.requestOptions({})
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            console.error(response.message);
          } else {
            console.log("Credito:", response);
            this.contadorArchivos = response.data.data;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    getCreditosOptimizados() {
      const userRoles = Security.getUserSucursal();
      console.log("Inicio", userRoles[0]);
      this.readyExcel = false;

      const payload = {
        sucursal: this.sucursalFiltro,
        estado: this.estadoFiltro,
        sucursales: userRoles[0],
      };
      console.log("payload", payload);
      // this.depto = userRoles[0]
      // this.estado = 'Activo'
      console.log("Inicio", payload);
      fetch(
        process.env.VUE_APP_API_URL + "/admin/credito/all",
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);

            console.error(response.message);
          } else {
            console.log("creditosOptimizados", response.data);

            this.creditosOptimizados = response.data.creditos.reverse();
            // this.creditosOptimizados = response.data.creditos
            this.ready = true;
            this.creditos = response.data.creditos.reverse();

            // for (let i = 0; i < this.creditos.length; i++) {
            //   fetch(process.env.VUE_APP_API_URL + `/admin/beneficiario-registro/${this.creditos[i].cliente.dni}`, Security.requestOptions({}))
            //   .then((response) => response.json())
            //   .then((response) => {
            //     if (response.error) {
            //       this.$emit('error', response.message);
            //       // console.error(response.message)
            //     } else {
            //       // console.log('Registro:', response)
            //       this.creditos[i].infoRegistro = response.data

            //       // this.idCredito = response.data.id
            //       // this.readyVerMas = true
            //     }
            //   })
            //   .catch(error => {
            //     this.$emit('error', error)
            //   })

            // }
            this.readyExcel = true;

            // this.getCreditos();
            // this.creditos ? this.initializeDataTable() : null;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    getCreditos() {
      const userRoles = Security.getUserSucursal();
      console.log("Inicio", userRoles[0]);

      const payload = {
        sucursal: userRoles[0],
        estado: this.estado,
      };
      console.log("payload", payload);
      this.depto = userRoles[0];
      this.estado = "Activo";
      console.log("Inicio", payload);
      fetch(
        process.env.VUE_APP_API_URL + "/admin/credito/all",
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);

            console.error(response.message);
          } else {
            console.log("Credito All getCredito()", response.data);

            this.creditos = response.data.creditos;
            this.creditos = response.data.creditos.reverse();
            this.readyExcel = true;
            // this.creditos ? this.initializeDataTable() : null;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    hoy() {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1; // Sumar 1 porque los meses comienzan desde 0
      let day = today.getDate();

      // Agregar un cero inicial si el mes o día es menor que 10 para mantener el formato 'YYYY-MM-DD'
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }

      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    async llamarEspejo(id) {
      console.log(id);
      Swal.fire({
        title: "¿Estás Seguro que desea Regresar a un pago atras?",
        icon: "warning",
        text: "¡Esta Función devolvera el credito al anterior que tenía!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("confirmado");
          fetch(
            process.env.VUE_APP_API_URL + `/admin/credito/devolver-credito`,
            Security.requestOptions({ idCredito: id })
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.$emit("error", response.message);
                console.error(response.message);
              } else {
                this.creditos = [];
                console.log("Credito:", response);
                this.buscarCredito(this.busquedaInput);
                location.reload();
              }
            })
            .catch((error) => {
              this.$emit("error", error);
            });
        }
      });
      // this.buscarCredito(this.busquedaInput)
    },
    handleSeeMore(id) {
      this.totalMontoPagado = 0;
      this.readyVerMas = false;
      console.log(id);
      fetch(
        process.env.VUE_APP_API_URL + `/admin/credito/${id}`,
        Security.requestOptions({})
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            console.error(response.message);
          } else {
            console.log("Credito Ver mas:", response);
            this.estadoProcesoBool = false;
            this.verMasData = response.data;
            this.getCountArchivos();
            this.idCredito = response.data.id;
            if (this.verMasData.esLocalizable) {
              this.esLocalizable = "true";
            } else {
              this.esLocalizable = "false";
            }

            this.estadoProceso = this.verMasData.estadoProceso;

            this.esRefinanciado = this.verMasData.esRefinanciado;

            if (this.estadoProceso === "") {
              this.estadoProcesoBool = true;
            }
            //Fetch Rnp
            this.asesor = this.verMasData.userAdmin;

            this.infoRegistro();
            

            this.readyVerMas = true;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });

      let payload2 = {
        idCredito: id,
      };
      fetch(
        process.env.VUE_APP_API_URL + `/admin/pagos/allById`,
        Security.requestOptions(payload2)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.error,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            // this.pagos = response.data.pagos.reverse();
            this.pagos = response.data.pagos;
            console.log("Pagos Hecho:", this.pagos);

            this.totalMontoPagado = this.pagos.reduce((total, pago) => {
              return total + pago.montoPagado;
            }, 0);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });

      // Asesor
      if (this.verMasData.userAdmin && this.sucursalesRoles[0] != "ALL") {
        this.getAsesor(this.verMasData.userAdmin);
      }
    },
    async getAsesor(id) {
      fetch(
        process.env.VUE_APP_API_URL + "/admin/user/get-asesor",
        Security.requestOptions({ idAsesor: id })
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);

            console.error(response.message);
          } else {
            console.log("Asesor Usuario:", response.data);
            this.asesorAdmin = response.data.asesor;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },

    infoRegistro() {
      fetch(
        process.env.VUE_APP_API_URL +
          `/admin/beneficiario-registro/${this.verMasData.cliente.dni}`,
        Security.requestOptions({})
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            console.error(response.message);
          } else {
            console.log("Registro:", response);
            this.verMasData.infoRegistro = response.data;
            console.log("Registro Ver mas data:", this.verMasData);

            // this.idCredito = response.data.id
            // this.readyVerMas = true
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    dateFormat(param) {
      var fechaISO = param;

      // Crear un objeto Date con la fecha proporcionada
      var fecha = new Date(fechaISO);

      // Obtener el día del mes (agregando un cero inicial si es necesario)
      var dia = ("0" + fecha.getUTCDate()).slice(-2);

      // Obtener el mes (agregando un cero inicial si es necesario)
      var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);

      // Obtener el año
      var anio = fecha.getUTCFullYear();

      // Formatear la fecha según tus necesidades
      var fechaFormateada = dia + "/" + mes + "/" + anio;

      console.log(fechaFormateada); // Salida: 01/12/2023

      return fechaFormateada;
    },

    dateFormat2(param) {
      const fecha = new Date(param);

      const dia = ("0" + fecha.getDate()).slice(-2); // ← local
      const mes = ("0" + (fecha.getMonth() + 1)).slice(-2);
      const anio = fecha.getFullYear();

      return `${dia}/${mes}/${anio}`;
    },

    handleShowPagos(id) {
      const payload = {
        idCredito: id,
      };

      fetch(
        process.env.VUE_APP_API_URL + "/admin/pagos/allById",
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            alert(response.message);
          } else {
            console.log("Solicitudes", response.data.solicitudes);
            this.solicitudes = response.data.solicitudes;
            this.ready = true;
            // Llama a la función initializeDataTable() después de un retraso de 2 segundos (2000 milisegundos)
            // setTimeout(this.initializeDataTable, 20000);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },

    handleMoveInfo(id, fechaUltimoPago) {
      this.idCredito = id;
      this.hacerPagoInfo = {};

      this.fechaUltimoPago = fechaUltimoPago?.toString().slice(0, 10);
      this.fechaPagado = "";
      // this.handleSeeMore(id);
      console.log("Fecha Ultima Pago :3", fechaUltimoPago);

      this.fechaPagado = fechaUltimoPago?.toString().slice(0, 10);
      console.log(this.fechaPagado, " Desde cartera");
      let payload = {
        idCredito: this.idCredito,
        fechaPagado: this.fechaPagado,
        montoPagado: 0,
      };

      fetch(
        process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`,
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            console.error(response.message);
          } else {
            console.log("Información del pago:", response);
            this.hacerPagoInfo = response.data;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });

      let payload2 = {
        idCredito: id,
      };
      fetch(
        process.env.VUE_APP_API_URL + `/admin/pagos/allById`,
        Security.requestOptions(payload2)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.error,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            console.log("Pagos Hecho:", response);
            this.pagos = response.data.pagos;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });

      // Check if fecha_ultima_cuota is a valid date
      // if (isNaN(new Date(fecha_ultima_cuota).getTime())) {
      //   console.error('Invalid date:', fecha_ultima_cuota);
      //   return;
      // }
      // console.log('fechaPagada', this.fechaPagado);
      // console.log('id', id);
      // console.log('montoPagado', this.montoPagado)
      // const date = new Date(fecha_ultima_cuota);

      // this.fechaUltimoPago = date.toISOString().slice(0, 10);
      // console.log(this.fechaUltimoPago);
      // this.fechaDataUltimoPago = date.toISOString().slice(0, 10);
      // let payload = {
      //   idCredito: id,
      //   fechaPagado: this.fechaPagado,
      //   montoPagado: 0
      // }
      // let payload = {
      //   idCredito: this.idCredito,
      //   fechaPagado: this.fechaPagado,
      //   montoPagado: parseFloat(this.montoPagado)
      // }
      // fetch(process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`, Security.requestOptions(payload))
      //   .then((response) => response.json())
      //   .then((response) => {
      //     if (response.error) {
      //       this.$emit('error', response.message);
      //       console.error(response.message)
      //     } else {
      //       console.log('pago Informacion:', response)
      //       this.hacerPagoInfo = response.data
      //       this.fechaUltimoPago = response.data.ultimaFechaPagada

      //     }
      //   })
      //   .catch(error => {
      //     this.$emit('error', error)
      //   })
    },
    simularPagoHoy(id) {
      let payload = {
        idCredito: id,
        fechaPagado: this.hoy(),
        montoPagado: 0,
      };

      fetch(
        process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`,
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);
            console.error(response.message);
          } else {
            console.log("Información del pago:", response);
            return {
              saldoInteres: 5,
              saldoMora: 5,
              diasMora: response.data.diasMora,
              fechaUltimaCuotaPagada: 5,
            };
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });

      return {
        saldoInteres: 5,
        saldoMora: 5,
        diasMora: 5,
        fechaUltimaCuotaPagada: 5,
      };
    },
    handleSubmitPago() {
      this.creditos = [];

      if (
        this.montoPagado !== "" &&
        this.fechaPagado !== "" &&
        this.validateInput()
      ) {
        Swal.fire({
          title: "¿Estás Seguro que desea Registrar el pago?",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            console.log("confirmado");
            try {
              const formData = new FormData();
              formData.append("idCredito", parseInt(this.idCredito));
              formData.append("fechaPagado", this.fechaPagado);
              formData.append("montoPagado", this.montoPagado);
              formData.append("idUsuario", store.user.id);
              formData.append("noReferenciaRecibo", String(this.noReferenciaRecibo));
              formData.append("noCuenta", this.noCuenta);
              formData.append("ifi", this.nombreBanco);
              formData.append("tipoPago", this.tipoPago);

              if (this.imagenPegada) {
                const file = await this.convertirURLaFile(this.imagenPegada, "recibo.png");
                formData.append("image", file, file.name);
              } else {
                formData.append("image", this.recibo, this.recibo?.name || "recibo.jpg");
              }

              const response = await fetch(
                process.env.VUE_APP_API_URL + "/admin/credito/registro-pago-con-recibo",
                Security.requestOptionsImagen(formData)
              );
              const data = await response.json();

              if (!response.ok || data.error) {
                Swal.fire({
                  icon: "error",
                  title: "No se pudo registrar el pago",
                  text: data.message || "Verifica los datos e intenta nuevamente.",
                  confirmButtonText: "LeÃ­do",
                });
                return;
              }

              Swal.fire({
                icon: "success",
                title: "Pago Registrado Exitosamente!",
                showConfirmButton: false,
                timer: 1500,
              });

              this.buscarCredito(this.busquedaInput);
              this.closeModalHacerPago();
              location.reload();
            } catch (error) {
              console.error("Error al registrar el pago:", error);
              Swal.fire({
                icon: "error",
                title: "No se pudo registrar el pago",
                text: error?.message || "OcurriÃ³ un error inesperado.",
                confirmButtonText: "LeÃ­do",
              });
            }
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Completa los datos",
          confirmButtonText: "LeÃ­do",
        });
      }
    },
    async submitImage(slug) {
      // console.log();
      const formData = new FormData();
      const newFileName = slug + ".jpg"; // Cambia esto al nuevo nombre que desees

      // Agregar el archivo con un nuevo nombre al FormData
      if (this.imagenPegada) {
        try {
          // Convertir la URL en un objeto File
          const file = await this.convertirURLaFile(
            this.imagenPegada,
            newFileName
          );

          // Agregar el objeto File al FormData
          formData.append("image", file, newFileName);
        } catch (error) {
          console.error("Error al convertir la imagen pegada:", error);
          // Manejar el error según sea necesario
        }
      } else {
        formData.append("image", this.recibo, newFileName);
      }

      try {
        const response = await fetch(
          process.env.VUE_APP_API_URL + "/admin/credito/obtener-imagen",
          Security.requestOptionsImagen(formData)
        );

        // Manejar la respuesta del backend según sea necesario
        console.log("Respuesta del servidor:", response);
        Swal.fire({
          // position: "top-end",
          icon: "success",
          title: "Imagen de Recibo enviada exitosamente!",
          showConfirmButton: false,
          timer: 1500,
        });

        location.reload();
      } catch (error) {
        console.error("Error al enviar la imagen:", error);
        Swal.fire({
          // position: "top-end",
          icon: "error",
          title: error,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      // router.push("/cartera");
      // location.reload()
    },
    cleanData() {
      this.montoPagado = "";
    },
    validateInput() {
      // let input = document.getElementById(idInput)

      // if (!input.checkValidity()) {
      //   input.classList.add("was-validated");
      // }
      // if (input.value.value === null || input.value.value === "" || input.value.value === 0) {
      //   input.classList.add("was-validated");
      // }

      if (this.fechaPagado == "") {
        document.getElementById("fechaPagado").style.border = "2px solid red";
        return false;
      }
      if (this.montoPagado == "") {
        document.getElementById("montoPago").style.border = "2px solid red";
        return false;
      }
      if (this.nombreBanco == "") {
        document.getElementById("nombreBanco").style.border = "2px solid red";
        return false;
      }
      if (this.noCuenta === "") {
        // document.getElementById("noCuenta").classList.add("was-validated");
        document.getElementById("noCuenta").style.border = "2px solid red";
        return false;
      }
      if (this.noReferenciaRecibo === "") {
        // document.getElementById("noCuenta").classList.add("was-validated");
        document.getElementById("noReferenciaRecibo").style.border =
          "2px solid red";
        return false;
      }
      if (this.recibo === null) {
        // document.getElementById("noCuenta").classList.add("was-validated");
        document.getElementById("formFile").style.border = "2px solid red";
        return false;
      }

      return true;
    },
    // Función para descargar la imagen desde la URL y convertirla en un objeto File
    async convertirURLaFile(url, nombreArchivo) {
      try {
        // Obtener la imagen desde la URL
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Error al obtener la imagen");
        }

        // Convertir la respuesta en un Blob
        const blob = await response.blob();

        // Crear un objeto File con el Blob
        const file = new File([blob], nombreArchivo, { type: blob.type });

        return file;
      } catch (error) {
        console.error("Error al convertir la URL en un objeto File:", error);
        throw error;
      }
    },
    compareStrings(str1, str2) {
      // Convertir el primer string a minúsculas y eliminar los espacios
      str1 = str1.toLowerCase().replace(/\s/g, "");
      // Convertir el segundo string a minúsculas y eliminar los espacios
      str2 = str2.toLowerCase().replace(/\s/g, "");
      // Comparar los dos strings
      if (str1 === str2) {
        return true;
      }
      return false;
    },

    generateExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Data");

      // Agrega las columnas al archivo Excel
      worksheet.columns = [
        { header: "No.", key: "No." },
        { header: "Estatus", key: "Estatus" },
        { header: "Departamento", key: "Departamento" },
        { header: "No. Prestamo", key: "No. Prestamo" },
        { header: "Rubro", key: "Rubro" },
        { header: "NOMBRE DEL CLIENTE", key: "NOMBRE DEL CLIENTE" },
        { header: "IDENTIDAD", key: "IDENTIDAD" },
        { header: "No. Tel/Cel", key: "No. Tel/Cel" },
        { header: "DIRECCION", key: "DIRECCION" },
        { header: "NEGOCIO", key: "NEGOCIO" },
        { header: "Producto", key: "Producto" },
        { header: "Fecha de Otorgamiento", key: "Fecha de Otorgamiento" },
        { header: "Fecha de Vencimiento", key: "Fecha de Vencimiento" },
        { header: "Monto Financiado", key: "Monto Financiado" },
        { header: "Frecuencia", key: "Frecuencia" },
        { header: "Periodo de gracia", key: "Periodo de gracia" },
        { header: "Valor de la Cuota", key: "Valor de la Cuota" },
        { header: "No. de cuotas", key: "No. de cuotas" },
        {
          header: "Capital mas intereses a pagar",
          key: "Capital mas intereses a pagar",
        },
        { header: "Plazo", key: "Plazo" },
        { header: "Tasa de Interes", key: "Tasa de Interes" },
        { header: "Interes corriente", key: "Interes corriente" },
        { header: "Interes Moratorios", key: "Interes Moratorios" },
        { header: "Capital", key: "Capital" },
        { header: "Total pagado", key: "Total pagado" },
        {
          header: "Fecha ultima cuota pagada",
          key: "Fecha ultima cuota pagada",
        },
        { header: "Fecha ultima de pago", key: "Fecha ultima de pago" },
        { header: "Número de cuotas pagadas", key: "Número de cuotas pagadas" },
        { header: "Saldo Capital", key: "Saldo Capital" },
        { header: "Saldo Intereses", key: "Saldo Intereses" },
        { header: "Saldo interes moratorio", key: "Saldo interes moratorio" },
        { header: "Cuotas al día", key: "Cuotas al día" },
        { header: "Capital atrasado", key: "Capital atrasado" },
        { header: "Interes atrasado", key: "Interes atrasado" },
        { header: "Calculo interes vencido", key: "Calculo interes vencido" },
        { header: "Cuotas vencidas", key: "Cuotas vencidas" },
        { header: "Dias vencidos", key: "Dias vencidos" },
        { header: "Rango 1-30 días", key: "Rango 1-30 días" },
        { header: "Monto vencido 1-30 días", key: "Monto vencido 1-30 días" },
        { header: "Rango 31-60 días", key: "Rango 31-60 días" },
        { header: "Monto vencido 31-60 días", key: "Monto vencido 31-60 días" },
        { header: "Rango 61-90 días", key: "Rango 61-90 días" },
        { header: "Monto vencido 61-90 días", key: "Monto vencido 61-90 días" },
        { header: "Rango de más 90 días", key: "Rango de más 90 días" },
        {
          header: "Monto vencido más 90 días",
          key: "Monto vencido más 90 días",
        },
      ];

      // Datos de prueba
      const testData = [
        {
          "No.": 1,
          Estatus: "Activo",
          Departamento: "Finanzas",
          "No. Prestamo": "P001",
          Rubro: "Préstamo personal",
          "NOMBRE DEL CLIENTE": "Juan Pérez",
          IDENTIDAD: "1234567890",
          "No. Tel/Cel": "9876543210",
          DIRECCION: "Calle Principal 123",
          NEGOCIO: "N/A",
          Producto: "Préstamo personal",
          "Fecha de Otorgamiento": "2023-01-15",
          "Fecha de Vencimiento": "2024-01-15",
          "Monto Financiado": 10000,
          Frecuencia: "Mensual",
          "Periodo de gracia": 0,
          "Valor de la Cuota": 1000,
          "No. de cuotas": 12,
          "Capital mas intereses a pagar": 12000,
          Plazo: 12,
          "Tasa de Interes": 0.1,
          "Interes corriente": 1000,
          "Interes Moratorios": 0,
          Capital: 11000,
          "Total pagado": 6000,
          "Fecha ultima cuota pagada": "2023-06-15",
          "Fecha ultima de pago": "2023-11-05",
          "Número de cuotas pagadas": 6,
          "Saldo Capital": 5000,
          "Saldo Intereses": 500,
          "Saldo interes moratorio": 0,
          "Cuotas al día": 6,
          "Capital atrasado": 0,
          "Interes atrasado": 0,
          "Calculo interes vencido": 0,
          "Cuotas vencidas": 0,
          "Dias vencidos": 0,
          "Rango 1-30 días": 0,
          "Monto vencido 1-30 días": 0,
          "Rango 31-60 días": 0,
          "Monto vencido 31-60 días": 0,
          "Rango 61-90 días": 0,
          "Monto vencido 61-90 días": 0,
          "Rango de más 90 días": 0,
          "Monto vencido más 90 días": 0,
        },
        {
          "No.": 2,
          Estatus: "Inactivo",
          Departamento: "Ventas",
          "No. Prestamo": "P002",
          Rubro: "Préstamo para negocio",
          "NOMBRE DEL CLIENTE": "Maria Rodriguez",
          IDENTIDAD: "0987654321",
          "No. Tel/Cel": "7890123456",
          DIRECCION: "Avenida Central 456",
          NEGOCIO: "Tienda de ropa",
          Producto: "Préstamo para negocio",
          "Fecha de Otorgamiento": "2023-03-10",
          "Fecha de Vencimiento": "2024-03-10",
          "Monto Financiado": 20000,
          Frecuencia: "Quincenal",
          "Periodo de gracia": 2,
          "Valor de la Cuota": 1500,
          "No. de cuotas": 10,
          "Capital mas intereses a pagar": 15000,
          Plazo: 12,
          "Tasa de Interes": 0.08,
          "Interes corriente": 800,
          "Interes Moratorios": 100,
          Capital: 14000,
          "Total pagado": 6000,
          "Fecha ultima cuota pagada": "2023-08-15",
          "Fecha ultima de pago": "2023-10-05",
          "Número de cuotas pagadas": 4,
          "Saldo Capital": 10000,
          "Saldo Intereses": 1000,
          "Saldo interes moratorio": 200,
          "Cuotas al día": 3,
          "Capital atrasado": 0,
          "Interes atrasado": 0,
          "Calculo interes vencido": 0,
          "Cuotas vencidas": 0,
          "Dias vencidos": 0,
          "Rango 1-30 días": 0,
          "Monto vencido 1-30 días": 0,
          "Rango 31-60 días": 0,
          "Monto vencido 31-60 días": 0,
          "Rango 61-90 días": 0,
          "Monto vencido 61-90 días": 0,
          "Rango de más 90 días": 0,
          "Monto vencido más 90 días": 0,
        },
      ];

      // Agrega los datos al archivo Excel
      testData.forEach((data) => {
        worksheet.addRow(data);
      });

      // Genera el archivo Excel
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "data.xlsx";
        a.click();
        URL.revokeObjectURL(url);
      });
    },
  },
  watch: {
    nombreBanco: function (nombreBanco) {
      const bancoSeleccionado = this.bancos.find(
        (banco) => banco.nombreBanco === nombreBanco
      );

      this.numerosDeCuenta = bancoSeleccionado?.cuentas || [];
      if (!this.numerosDeCuenta.includes(this.noCuenta)) {
        this.noCuenta = "";
      }
    },
    data: function (data) {
      console.log("data", data);
    },
    verMasData: function (verMasData) {
      console.log("verMasData", verMasData);
    },
    creditos: function (creditos) {
      console.log("creditos", creditos);
    },
    busqueda: function (busqueda) {
      console.log("busca", busqueda);
    },
    sucursal: function (sucursal) {
      // const payload = {
      //   sucursal: userRoles[0],
      //   estado: this.estado
      // }
      console.log("sucursal", sucursal);
      // if (sucursal === 'Todos') {

      // }
    },
    esRefinanciado: function (newValue, oldValue) {
      if (this.verMasData.esRefinanciado != newValue) {
        Swal.fire({
          title: "¿Desea cambia el estado de Refinanciamiento?",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar!",
        }).then((result) => {
          if (result.isConfirmed) {
            let payload = {
              idCredito: this.verMasData.id,
              esRefinanciado: this.esRefinanciado,
            };

            console.log("confirmado");
            fetch(
              process.env.VUE_APP_API_URL + `/admin/credito/es-refinanciado`,
              Security.requestOptions(payload)
            )
              .then((response) => response.json())
              .then((response) => {
                if (response.error) {
                  this.$emit("error", response.message);
                  console.error(response.message);
                } else {
                  console.log("Update", response);
                  // location.reload();
                  console.log("Se cambia", oldValue, "por", newValue);
                }
              })
              .catch((error) => {
                this.$emit("error", error);
              });
          } else {
            this.esRefinanciado = oldValue;
          }
        });
      }
    },

    estado: function (estado) {
      this.creditos = [];
      this.ready = false;
      const userRoles = Security.getUserSucursal();

      const payload = {
        sucursal: userRoles[0],
        estado: estado,
      };

      if (this.sucursal != "MOSTRAR TODAS") {
        payload.sucursal = this.sucursal;
      }

      fetch(
        process.env.VUE_APP_API_URL + "/admin/credito/all",
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit("error", response.message);

            console.error(response.message);
          } else {
            console.log("Creditos All:", response.data);

            this.creditos = response.data.creditos.reverse();
            this.ready = true;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },

    fechaPagado(newValue, oldValue) {
      // console.log('Nueva fecha pagada:', newValue);
      // console.log('Antigua fecha pagada:', oldValue);

      // console.log(this.fechaUltimoPago)
      //Recordar Activar en Produccion
      // if (newValue>=this.fechaUltimoPago?.slice(0, 10) && newValue <= new Date().toISOString().slice(0, 10)) {
      if (
        newValue >= this.fechaUltimoPago?.slice(0, 10) ||
        this.Admin ||
        this.modoThanos
      ) {
        let payload = {
          idCredito: this.idCredito,
          fechaPagado: newValue,
          montoPagado: 0,
        };
        this.hacerPagoInfo = {};
        fetch(
          process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`,
          Security.requestOptions(payload)
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              this.$emit("error", response.message);
              console.error(response.message);
            } else {
              console.log("Información del pago:", response);
              this.hacerPagoInfo = response.data;
            }
          })
          .catch((error) => {
            this.$emit("error", error);
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "La fecha no puede ser menor a la fecha del ultimo pago o mayor a la fecha actual",
        });
        this.fechaPagado = oldValue;
      }
      // if (newValue?.length >= 10 && newValue < this.fechaUltimoPago?.slice(0, 10)) {
      //   this.fechaPagado = ''; // Reinicia fechaPagado si es menor que fechaUltimoPago
      // } else {
      //   let payload = {
      //     idCredito: this.idCredito,
      //     fechaPagado: newValue,
      //     montoPagado: 0
      //   };

      //   fetch(process.env.VUE_APP_API_URL + `/admin/credito/simular-pago`, Security.requestOptions(payload))
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.error) {
      //         this.$emit('error', response.message);
      //         console.error(response.message);
      //       } else {
      //         console.log('Información del pago:', response);
      //         this.hacerPagoInfo = response.data;
      //       }
      //     })
      //     .catch(error => {
      //       this.$emit('error', error);
      //     });
      // }
    },
  },
};
</script>

<style>
.empty-state {
  padding: 1.3rem 0.5rem;
  color: #45618f;
}

.empty-state i {
  display: block;
  font-size: 1.6rem;
  color: #7f93b8;
}

.verificar-cartera {
  height: 20px !important;
  margin-bottom: 10px;
}

.folder {
  background: #3a79ee;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  text-decoration: none;
}

.folder:hover {
  background: #2e70eb;
}

.folder i {
  font-size: 40px;
  margin: 15px;
  color: rgb(255, 255, 255);
}

.modal-footer .estado-verificado {
  width: 100%;
  text-align: center;
}

#Coordinacion,
#cordinadorSucursal {
  width: 100% !important;
}

.btn-behance {
  margin-left: 40px !important;
}

#tablaPlanPagos {
  > tr {
    > th {
      padding: 0.5rem;
    }

    > td {
      padding: 0.5rem;
    }
  }
}

#myTable_wrapper {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Tabla Cartera */
#myTable thead tr th {
  font-size: 0.8rem;
  color: #1c355f;
  border-bottom: 2px solid #d7e2f5;
}

#myTable tbody tr td {
  font-size: 0.8rem;
  padding-block: 5px;
}

#myTable tbody tr td button {
  font-size: 0.8rem;
}

.dataTables_paginate {
  display: flex;
  gap: 20px;
  width: 100%;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;

  > a {
    border-radius: 5px;
    border: 1px solid #f8f8f8;
    background-color: #3a79ee;
    padding: 5px 10px;
    font-size: 0.9rem;
    color: #021a47;
    text-decoration: none;
    cursor: pointer;
  }

  > span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    > a {
      border-radius: 5px;
      border: 1px solid #b9b9b9;
      padding: 5px 10px;
      font-size: 0.9rem;
      color: #021a47;
      background-color: #f0f0f0;
      text-decoration: none;
      cursor: pointer;
    }
  }

  color: #021a47;
}

#myTable_filter {
  margin-left: 10px;
  width: 200px;
  float: flex-end;

  > label input[type="search"] {
    font-size: 0.9rem;
    border-radius: 5px;
    margin-left: 10px;
    margin-top: 10px;
    height: 30px;
    border: 1px solid #021a47;
  }
}

select[name="myTable_length"] {
  border: 1px solid #021a47;
  border-radius: 5px;
  height: 30px;
  width: 100px;
  font-size: 0.9rem;
  text-align: center;
}

button {
  color: white;
}

.tb_custom {
  padding: 0;
  font-size: 0.85rem;
  width: 100%;
  margin: 0;
  border: none;

  > .trCustom_tb {
    padding: 0;
    margin: 0;
    text-align: left;

    > th {
      padding: 0;
      margin: 0;
      border: none;
    }

    > td {
      color: #233d6d;
      font-size: 0.9rem;
      padding: 0;
      margin: 0;
      border: none;
      text-align: right;
    }
  }
}

.resumenContent {
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: 0;
  padding: 0;

  > .resumenContent__item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
    margin: 0;
    padding: 0;

    > h4 {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
      color: #021a47;
    }

    > p {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
}

.btn-estado {
  margin-top: 0%;
  color: white;
}

.btn-estado:hover {
  color: rgb(232, 232, 232);
}

.btn-estado:active {
  color: rgb(232, 232, 232);
}

.btn-ver-pagos {
  margin-top: 0;
  margin-left: 60%;
  margin-right: 0.2%;
  color: white;
}

.btn-ver-pagos:hover {
  color: rgb(247, 245, 255);
}

/* Media query para dispositivos móviles */
@media (max-width: 768px) {
  .btn-ver-pagos {
    margin-left: 0px;

    /* ajusta este valor según sea necesario */
  }
}

/* horizontal-scrollable>.row {
  overflow-x: auto;
  white-space: nowrap;
}

.horizontal-scrollable>.row>.col-xs-4 {
  display: inline-block;
  float: none;
} */

.horizontal-scrollable {
  overflow-x: auto;
  white-space: nowrap;
}

.horizontal-scrollable .col-xs-4 {
  display: inline-block;
  float: none;
  vertical-align: top;
  /* Añade esto para corregir problemas de alineación */
}

/* Decorations */

.col-xs-4 {
  color: white;
  font-size: 24px;
  padding-bottom: 20px;
  padding-top: 18px;
}

.col-xs-4:nth-child(2n + 1) {
  background: green;
}

.col-xs-4:nth-child(2n + 2) {
  background: black;
}

.btn-am {
  height: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 0px;
}

/* .ver-mas-right {} */

.total-pagado {
  /* height: 300px ; */
  background-color: #3a79ee;
  color: white;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  /* justify-content: center; */
  padding: 7%;
}

.pagado {
  width: 100%;
}

.pagado h4 {
  font-size: 13px;
}

.pagado p {
  font-size: 12px;
  font-weight: 300;
}

.btn-volver {
  background-color: #3a79ee;
  color: white;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  font-size: 0.9rem;
  font-weight: 300;
  width: 60px;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: center;
}

.registro-pago {
  border-top: 3px solid #ff910088;
  border-right: 3px solid #4286f467;
  padding: 10px;
  padding-top: 25px;
  border-radius: 15px;
}

.modal-footer {
  padding: 0;
  padding-bottom: 5px;
  padding-right: 5px;
}

.generar-buscar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* gap: 10px; */
  width: 100%;
  /* background-color: #d5d5d5; */
  margin: 15px;
  padding: 10px;
  border-radius: 15px;
  color: white;
  width: 95%;
}

.imagen-recibo {
  width: 80%;
  margin-top: 5px;
}

.importante-pagar {
  border-radius: 30px;
  border: 1px solid rgb(160, 160, 160);
  padding-block: 7px;
  padding-inline: 15px;
}

.importante-pagar:hover {
  border: 1px solid rgb(218, 189, 189);
}

.creditos-shell {
  width: 100%;
  padding: 0;
  background: #f4f7fb;
}

.creditos-panel {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8edf5;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(26, 41, 61, 0.08);
}

.creditos-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 14px;
  border-bottom: 1px solid #edf1f7;
}

.creditos-header h2 {
  margin: 0;
  color: #12213a;
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0;
}

.creditos-eyebrow {
  margin: 0 0 4px;
  color: #2f73e0;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.creditos-count {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 12px;
  color: #2f73e0;
  background: #eef5ff;
  border: 1px solid #dce9ff;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 700;
}

.creditos-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #edf1f7;
}

.summary-card {
  min-width: 0;
  padding: 14px 16px;
  background: #fbfcff;
  border: 1px solid #e9eef7;
  border-radius: 6px;
}

.summary-label,
.summary-card small {
  display: block;
  color: #7a879b;
  font-size: 0.74rem;
  font-weight: 600;
}

.summary-card strong {
  display: block;
  margin: 3px 0;
  color: #17243b;
  font-size: 1.25rem;
  line-height: 1.15;
}

.table-frame {
  width: 100%;
  overflow-x: auto;
  padding: 0 18px 14px;
}

#myTable_wrapper {
  padding: 14px 0 0;
}

#myTable_wrapper .dataTables_length,
#myTable_wrapper .dataTables_info {
  color: #718099;
  font-size: 0.82rem;
}

.creditos-table {
  width: 100% !important;
  margin: 0 !important;
  color: #33415c;
  border-collapse: separate;
  border-spacing: 0;
}

.creditos-table thead th,
#myTable thead tr th {
  padding: 13px 12px;
  color: #8a96aa;
  background: #ffffff;
  border-top: 0;
  border-bottom: 1px solid #e8edf5;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  white-space: nowrap;
}

.creditos-table tbody td,
#myTable tbody tr td {
  padding: 12px;
  color: #3e4b63;
  background: #ffffff;
  border-bottom: 1px solid #edf1f7;
  font-size: 0.82rem;
  vertical-align: middle;
}

.creditos-table tbody tr:hover td {
  background: #f8fbff;
}

.codigo-cell {
  color: #77859a !important;
  font-weight: 700;
  white-space: nowrap;
}

.beneficiario-cell {
  min-width: 220px;
  text-align: left;
}

.beneficiario-content {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}

.beneficiario-content strong {
  display: block;
  color: #17243b;
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1;
}

.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  color: #2f73e0;
  background: #eef5ff;
  border: 1px solid #dbe8ff;
  border-radius: 50%;
  font-size: 0.62rem;
  font-weight: 800;
}

.estado-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.estado-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.estado-badge--active {
  color: #13975f;
  background: #eaf9f1;
}

.estado-badge--cancelled {
  color: #cf3d46;
  background: #fff0f1;
}

.estado-badge--overdue {
  color: #b97912;
  background: #fff7e6;
}

.estado-badge--neutral,
.estado-badge--empty {
  color: #64748b;
  background: #f1f5f9;
}

.monto-cell {
  color: #17243b !important;
  font-weight: 800;
  white-space: nowrap;
}

.monto-cell span {
  color: #8a96aa;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 170px;
}

.action-button,
#myTable tbody tr td button.action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  box-shadow: none;
}

.action-button--pay {
  color: #ffffff;
  background: #2f73e0;
  border-color: #2f73e0;
}

.action-button--pay:hover {
  color: #ffffff;
  background: #2564c8;
}

.action-button--view {
  color: #2f73e0;
  background: #ffffff;
  border-color: #d8e4f8;
}

.action-button--view:hover {
  color: #1f5dbd;
  background: #f3f8ff;
}

.action-button--disabled {
  color: #8895a8;
  background: #f1f4f8;
  border-color: #e3e8f0;
}

.btn-volver {
  width: 34px;
  height: 34px;
  min-width: 34px;
  margin: 0 auto;
  padding: 0;
  color: #64748b;
  background: #ffffff;
  border: 1px solid #dce4ef;
  border-radius: 6px;
}

.btn-volver:hover {
  color: #2f73e0;
  background: #f3f8ff;
}

.dataTables_paginate {
  justify-content: flex-end;
  gap: 6px;
  margin: 14px 0 0;
}

.dataTables_paginate > a,
.dataTables_paginate > span > a {
  min-width: 34px;
  min-height: 32px;
  padding: 7px 10px;
  color: #64748b;
  background: #ffffff;
  border: 1px solid #dce4ef;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  text-align: center;
}

.dataTables_paginate > a:hover,
.dataTables_paginate > span > a:hover,
.dataTables_paginate > span > a.current {
  color: #2f73e0;
  background: #eef5ff;
  border-color: #bcd5ff;
}

select[name="myTable_length"] {
  width: auto;
  min-width: 76px;
  height: 34px;
  margin: 0 6px;
  color: #33415c;
  border: 1px solid #dce4ef;
  border-radius: 6px;
}

@media (max-width: 992px) {
  .creditos-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .creditos-shell {
    padding: 0;
  }

  .creditos-panel {
    border-radius: 0;
  }

  .creditos-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 18px 16px 12px;
  }

  .creditos-summary {
    grid-template-columns: 1fr;
    padding: 14px 16px;
  }

  .table-frame {
    padding: 0 10px 12px;
  }
}
</style>
